export default __webpack_public_path__ + "static/news2-e874e3c5d1fdf62c0bff9bc2c4bb26f9.jpg";